import styled from "styled-components";

const Title = styled.h1`
  color: white;
  margin-bottom: 0;
  margin-top: 20px;
  font-size: 6em;
  font-family: "Spicy Rice", cursive;
  color: #ff7140;
  -webkit-text-stroke-width: 1px;
  stroke-width: 1px;
  -webkit-text-stroke-color: white;
`;

const Header = styled.h1`
  font-size: 3em;
  font-family: "Spicy Rice", cursive;
  color: #ff7410;
`;

const Header2 = styled.h2`
  font-size: 2em;
  font-family: "Spicy Rice", cursive;
  color: darkslategray;
`;

const SubHeader = styled.h6`
  margin: 0 auto;
  font-style: italic;
  color: white;
`;

export { Title, Header, Header2, SubHeader };
